
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  keywords,
  type = 'website'
}) => {
  const siteTitle = "Cebime Gelsin";
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Emlak & Oto Pazar Yeri`;
  const metaDescription = description || "Emlak ve araç alım satım taleplerinizi kolayca oluşturun, kurumsal firmalardan en iyi teklifler cebinize gelsin. Tersine pazar yeri.";
  const metaKeywords = keywords || "emlak, araba, otomobil, konut, satılık, kiralık, teklif al, pazar yeri, sahibinden, galeri, emlak ofisi";

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      
      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:site_name" content={siteTitle} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      
      {/* Canonical */}
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default SEO;
